import { Rating } from "primereact/rating";
import { useToastContext } from "../../contexts/ToastContext/ToastContext";
import useRatingProduct from "../../hooks/useRatingProduct";
import localeText from "../../locale";

const ProductRating = ({ productId, product }) => {
  const { showErrorToast } = useToastContext();
  const { ratingProduct } = useRatingProduct({
    productId,
    onError: (code) => showErrorToast({ code }),
  });
  return (
    <>
      {ratingProduct && (
        <div className="flex gap-3 align-items-center justify-content-start mb-3">
          <Rating value={Math.floor(ratingProduct.rate)} readOnly stars={5} cancel={false} />
          <div>
            {ratingProduct.rate > 0 && (
              <a
                className="inline-block text-left underline text-xs"
                style={{ color: "#7A869A" }}
                href="#productReviews"
              >
                <span>
                  {"(" + ratingProduct.count}{" "}
                  {ratingProduct.count > 1
                    ? localeText("ratings") + ")"
                    : localeText("rating") + ")"}
                </span>
              </a>
            )}
          </div>
          <div className="text-xs underline" style={{ color: "#7A869A" }}>
            {"("}Cod. {product.id}
            {")"}
          </div>
        </div>
      )}
    </>
  );
};

export default ProductRating;
